<template>
	<div id="app">
		<BaseErrors />
		<Header />
		<router-view/>
		<!-- <footer><label>© ГБУ РК «ТФИ РК» 2012 - 2018</label></footer> -->
	</div>
</template>

<script>
import Header from '@/components/views/Shared/Header'
import BaseErrors from '@/components/views/Shared/BaseErrors'
export default {
	name: 'App',
	components: { Header, BaseErrors}
}
</script>

<style src="./assets/main.css"></style>


// WEBPACK FOOTER //
// src/App.vue